export default __webpack_public_path__ + "static/media/ThumnailBanner.d1341358.webp";